import { Divider, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { ResponsiveStyleValue, StandardCSSProperties } from '@mui/system';

import logo from '@/assets/sofar-logomark-blue.png';

type FooterItem = {
    name: string;
    url: string;
    isExternal?: boolean;
    isDisabled?: boolean;
};

const footerLinks: FooterItem[] = [
    { name: 'Support', url: 'https://www.sofarocean.com/support' },
    { name: 'Privacy policy', url: 'https://www.sofarocean.com/legal/privacy-policy' },
    { name: 'Terms of use', url: 'https://www.sofarocean.com/legal/terms-of-use' },
];

export const Footer = ({ marginTop = 6 }: { marginTop?: ResponsiveStyleValue<StandardCSSProperties['marginTop']> }) => {
    return (
        <Box>
            <Divider sx={{ mt: marginTop }} />
            <Container maxWidth="lg" component="footer">
                <Stack
                    sx={{ width: '100%', my: 1 }}
                    flexWrap="wrap"
                    spacing={4}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
                        <Box component="img" src={logo} height={22} />
                        <Typography variant="body2" color="text.secondary" align="center">
                            {'Copyright © '}
                            <Link color="text.secondary" href="https://sofarocean.com/" underline="hover">
                                Sofar Ocean
                            </Link>{' '}
                            {new Date().getFullYear()}
                            {'.'}
                        </Typography>
                    </Stack>
                    <Stack direction="row" gap={2} alignItems={{ xs: 'center', md: 'flex-start' }}>
                        {footerLinks.map((link) => {
                            if (link.isDisabled) {
                                return null;
                            }
                            return (
                                <Link
                                    key={link.url}
                                    href={link.url}
                                    variant="body2"
                                    color="text.secondary"
                                    underline="hover"
                                    sx={{ my: 0.5 }}
                                >
                                    {link.name}
                                </Link>
                            );
                        })}
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
};
